import { useEffect } from 'react';
import logoJersu from '../../assets/img/grupos/Geral.png';
import './styles.scss';

export default function GrupoLanding({ config }) {
  useEffect(() => {
    const s = document.getElementById('sticky');
    const h = document.getElementById('ctaHero');
    if (!s || !h) return;
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting) s.classList.remove('show');
        else s.classList.add('show');
      });
    }, { threshold: 0 });
    io.observe(h);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!config.pixelId) return;
    const id = `fb-pixel-${config.pixelId}`;
    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.id = id;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${config.pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [config.pixelId]);

  const {
    tipo,
    titulo = 'OFERTAS',
    subtitulo = 'Produtos pela METADE DO PREÇO',
    imagem,
    cor,
    selo = 'JERSU INDICA',
    wppIcon,
  } = config;

  const redir = `https://jersu.com.br/redirecionar?tipo=${tipo}`;

  const wppSvg = wppIcon ? (
    <svg className="ic-wpp" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M16.04 4C9.93 4 4.97 8.96 4.97 15.07c0 2.13.6 4.13 1.64 5.84L4.6 28l7.27-1.9a11 11 0 0 0 4.17.82h.01c6.11 0 11.07-4.96 11.07-11.07C27.12 8.96 22.16 4 16.04 4zm0 20.27h-.01a9.2 9.2 0 0 1-4.69-1.28l-.34-.2-3.48.91.93-3.39-.22-.35a9.18 9.18 0 0 1-1.41-4.9c0-5.08 4.13-9.21 9.22-9.21 2.46 0 4.78.96 6.52 2.7a9.16 9.16 0 0 1 2.7 6.52c0 5.09-4.14 9.21-9.22 9.21zm5.05-6.9c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.74-1.38-1.65-1.54-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.36.99 2.67 1.12 2.85.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z"/>
    </svg>
  ) : null;

  const heroMedia = imagem ? (
    <img
      className="hero-img"
      src={imagem}
      alt={titulo}
      style={cor ? { backgroundColor: cor } : undefined}
    />
  ) : (
    <div className="hero-avatar" style={cor ? { backgroundColor: cor } : undefined}>
      <span>{titulo}</span>
    </div>
  );

  return (
    <>
      {config.pixelId && (
        <noscript>
          <img
            height="1"
            width="1"
            style={{ display: 'none' }}
            src={`https://www.facebook.com/tr?id=${config.pixelId}&ev=PageView&noscript=1`}
          />
        </noscript>
      )}
      <div id="lp">
        <div className="orbs">
          <div className="orb g" />
          <div className="orb b" />
        </div>
        <div className="livebar">
          <span>🎯 APROVEITE AGORA AS MELHORES PROMOÇÕES DE 2026</span>
        </div>
        <div className="wrap">
          <header className="hero">
            <h1 className="rv d2">
              <span className="hl-line">🚨 {selo}</span>
              <span className="hl-line">
                <span className="hl">100% GRATUITO</span>
                🚨
              </span>
            </h1>
            <div className="hero-media rv d3">
              <div className="ring" />
              {heroMedia}
            </div>
            <p
              className="subhead rv d4"
              dangerouslySetInnerHTML={{ __html: subtitulo }}
            />
            <a
              className="cta rv d4"
              href={redir}
              id="ctaHero"
            >
              {wppSvg}
              ENTRAR NO GRUPO
            </a>
            <div className="seals rv d5">
              <span>
                <span className="ck">✓</span>
                JÁ SOMOS +200 MIL MEMBROS
              </span>
            </div>
            <div className="scroll-hint rv d6">▼ veja o que você recebe</div>
          </header>

          <section className="benefits">
            <span className="eyebrow">O que você recebe</span>
            <h2>
              OFERTAS 100% CONFIÁVEIS<br />10 ANOS DE EXPERIÊNCIA
            </h2>
            <div className="stack">
              <div className="card">
                <div className="cico">🛰️</div>
                <div>
                  <h3>Promoções monitoradas 24h</h3>
                  <p>Eu rastreio todas as lojas dia e noite pra você.</p>
                </div>
              </div>
              <div className="card">
                <div className="cico">🎟️</div>
                <div>
                  <h3>Cupons exclusivos</h3>
                  <p>Descontos que não aparecem em nenhum outro lugar.</p>
                </div>
              </div>
              <div className="card">
                <div className="cico">⚡</div>
                <div>
                  <h3>Ofertas relâmpago</h3>
                  <p>Aviso antes de acabar — você compra primeiro.</p>
                </div>
              </div>
              <div className="card">
                <div className="cico">✅</div>
                <div>
                  <h3>Só promoções de verdade</h3>
                  <p>Só o que realmente está valendo muito a pena.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="proof">
            <span className="eyebrow">Junte-se à comunidade</span>
            <div className="stats">
              <div className="stat">
                <div className="num">+200 MIL</div>
                <div className="lbl">Membros ativos</div>
              </div>
              <div className="stat">
                <div className="num">+100</div>
                <div className="lbl">Ofertas por dia</div>
              </div>
            </div>
            <div className="stars">★★★★★</div>
            <small>Mais de 200 mil pessoas já economizam todo dia.</small>
          </section>

          <section className="video">
            <span className="eyebrow">Assista</span>
            <h2>
              Como funcionam<br />os grupos?
            </h2>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/90yKNjTXuMI"
                title="Vídeo YouTube"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </section>

          <section className="final">
            <div className="final-box">
              <h2>
                Sua próxima compra<br />pode sair pela metade.
              </h2>
              <p>Entrada gratuita. Vagas limitadas.</p>
              <a className="cta" href={redir}>
                {wppSvg}
                ENTRAR NO GRUPO AGORA
              </a>
              <div className="micro">🔒 Grupo oficial · Sem custo</div>
            </div>
          </section>

          <footer className="lp-footer">
            <img src={logoJersu} alt="Jersu Indica Ofertas" className="lp-footer-logo" />
            <p>© Jersu Indica Ofertas<br />Todos os direitos reservados.</p>
          </footer>
        </div>
        <div className="sticky" id="sticky">
          <a className="cta" href={redir}>
            {wppSvg}
            ENTRAR NO GRUPO
          </a>
        </div>
      </div>
    </>
  );
}
